/**
 * Clears specific session storage items and sets guarding checklist flag
 */
export const clearSessionData = (): void => {
  sessionStorage.removeItem('draftId');
  sessionStorage.setItem('guardingChecklist', 'false');
};